<template>
	<div class="eia-beta-banner">
		<div class="eia-page-boundary-container">
			<div class="beta-label">BETA</div>
			<p>This is a new service - your feedback will help us improve it.</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'eia-beta-banner',
};
</script>

<style lang="scss" scoped>
.eia-beta-banner {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	background: $color-main;
	width: 100%;
	padding: 32px 0;
	border-bottom: 1px solid $color-grey-medium;

	.beta-label {
		margin-right: 24px;
		display: inline-flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		border: 1px solid transparent;
		font-family: $font-family;
		font-size: $text-subheading-small;
		font-weight: $weight-bold;
		user-select: none;
		line-height: $text-subheading-small;
		pointer-events: none;
		text-decoration: none;
		transition:
			box-shadow 50ms linear,
			color 150ms linear,
			border-color 150ms linear,
			background 150ms linear;

		border-radius: $radius-full;
		min-width: 160px;
		background: transparent;
		color: $color-white;
		padding: 17px;
		margin: 1px 24px 1px 1px;
		box-shadow: 0 0 0 1px $color-white;
	}



	p {
		color: $color-white;
		font-size: $text-subheading-small;
	}
}
</style>
